<template>
  <div  :style="{
    gridRowEnd: ('span ' + rowSpanData),
    gridColumnEnd: ('span ' + colSpan),
  }"
  >

    <div ref="self">
      <slot ></slot>
    </div>

  </div>
</template>

<script>
export default {
  name: "DdGridItem",
  mounted() {
    if (this.rowSpan) this.rowSpanData = this.rowSpan;
    else {
      this.setInitialRowSpan();
      this.stretchToContainer();
    }
    let observer = new ResizeObserver(() => this.onResize());
    observer.observe(this.$refs.self);
  },
  methods: {
    onResize() {
      this.unstretchContainer();
      this.setInitialRowSpan();
      this.stretchToContainer();
    },
    setInitialRowSpan() {
      let rowHeight = 0;
      let spacing = 16;

      let element = this.$refs.self;
      let width = element.offsetHeight / ( rowHeight + spacing )
      this.rowSpanData = Math.floor(width);
    },
    stretchToContainer() {
      this.$refs.self.style.height = '100%';
      this.$refs.self.childNodes[0].style.height = '100%';
    },
    unstretchContainer() {
      this.$refs.self.style.height = 'auto';
      this.$refs.self.childNodes[0].style.height = 'auto';
    }
  },
  data() {
    return {
      rowSpanData: 0,
    }
  },
  props: {
    rowSpan: {
      type: Number,
      required: false,
    },
    colSpan: {
      type: Number,
      default: () => 1,
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

</style>
